import { render, staticRenderFns } from "./ButtonTooltip.vue?vue&type=template&id=2ebe6de2&scoped=true"
import script from "./ButtonTooltip.vue?vue&type=script&lang=ts"
export * from "./ButtonTooltip.vue?vue&type=script&lang=ts"
import style0 from "./ButtonTooltip.vue?vue&type=style&index=0&id=2ebe6de2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe6de2",
  null
  
)

export default component.exports